module.exports = __webpack_public_path__ + "static/mailer-9e2884d34eba0e18f105700c2e7ed479.jpg";